import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
	selector: 'app-horario-data',
	templateUrl: './horario-data.component.html',
	styleUrls: ['./horario-data.component.scss'],
})
export class HorarioDataComponent implements OnInit {
	@Input() dataAgressions: any;
	@Input() elId: string;

	constructor() {}

	ngOnInit(): void {
		this.createGraphHeatMap();
		this.createGraphDiasSemana();
		this.createGraphTurno();
	}

	ngOnChanges(): void {
		this.createGraphHeatMap();
		this.createGraphDiasSemana();
		this.createGraphTurno();
	}

	public graph: any = {
		data: [
			{
				z: [
					[1, null, 30, 50, 1],
					[20, 1, 60, 80, 30],
					[30, 60, 1, -10, 20],
				],
				x: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
				y: ['Morning', 'Afternoon', 'Evening'],
				type: 'heatmap',
				hoverongaps: false,
			},
		],
	};

	@HostListener('window:resize', ['$event'])
	onResize(event: Event) {
		// Chame a função de redimensionamento quando a janela mudar de tamanho
		this.redimensionarGrafico();
	}
	private redimensionarGrafico() {
		// Calcule a largura e altura desejadas com base na largura do contêiner
		const larguraConteiner = document.querySelector('plotly-plot')?.clientWidth
			? document.querySelector('plotly-plot').clientWidth
			: 1300;
		const alturaConteiner = larguraConteiner * 0.4; // Defina a relação largura/altura adequada

		// Atualize o layout do gráfico
		this.graph.layout = {
			...this.graph.layout,
			width: larguraConteiner,
			height: alturaConteiner,
		};
	}

	noHourData = false;
	createGraphHeatMap() {
		let agrupamento: number[][] = [[]];

		if (
			this.dataAgressions?.calendar_heat_map &&
			this.dataAgressions.calendar_heat_map.length > 0
		)
			this.noHourData = false;
		else this.noHourData = true;

		if (this.dataAgressions)
			agrupamento = agruparPorWeekDay(
				this.dataAgressions.calendar_heat_map.sort(ordenarPorHora)
			);
		if (agrupamento.length) {
			this.graph = {
				config: {
					displayModeBar: false,
					displaylogo: false,
				},
				data: [
					{
						z: agrupamento,
						x: [
							'6h',
							'7h',
							'8h',
							'9h',
							'10h',
							'11h',
							'12h',
							'13h',
							'14h',
							'15h',
							'16h',
							'17h',
							'18h',
							'19h',
							'20h',
							'21h',
							'22h',
							'23h',
							'00h',
							'1h',
							'2h',
							'3h',
							'4h',
							'5h',
						],
						y: ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SAB'],
						xgap: 5,
						ygap: 5,
						displayModeBar: false,
						type: 'heatmap',
						hoverongaps: false,
						colorscale: [
							[0, '#C8BFFF'],
							[0.2, '#A396FF'],
							[0.4, '#7E6CFE'],
							[0.6, '#5B43D9'],
							[0.8, '#360AB7'],
							[1, '#180064'],
						],

						colorbar: {
							tickfont: {
								family: 'Roboto',
								size: 12,
								color: '#938F94',
							},
							bordercolor: '#fff',
							outlinecolor: '#fff',
							thickness: 10, // Espessura da barra de cores
						},
					},
				],
				layout: {
					title: {
						text: '<span style="margin-left:30px" class="title">Horário</span> ',
						font: {
							family: 'Roboto', // Fonte desejada (Roboto)
							size: 24, // Tamanho da fonte (22px)
							color: '#000000', // Cor do texto (preto)
							weight: '700', // Negrito
						},
						x: 0.03,
						xanchor: 'left',
					},
					plot_bgcolor: '#ffffff00',
					paper_bgcolor: '#ffffff00',
					xaxis: {
						ticks: '',
						ticksuffix: '',
						showgrid: false,
						showline: false, // Oculta a linha do eixo X
						tickfont: {
							family: 'Roboto',
							color: '#938F94',
							size: 12,
						},
					},
					yaxis: {
						scaleanchor: 'x',
						ticksuffix: '   ',
						ticks: '',
						showgrid: false,
						showline: false, // Oculta a linha do eixo X
						tickfont: {
							family: 'Roboto',
							color: '#938F94',
							size: 12,
						},
					},
					displayModeBar: false,
				},
			};
		}
		this.redimensionarGrafico();
	}

	weekdayChart: Chart | null = null;
	noWeekdayData = false;
	createGraphDiasSemana() {
		const weekdaysPercentages =
			this.dataAgressions?.category_counts_percentage.week_day;

		const canvas = document.getElementById(
			this.elId + 'myChartWeekDays'
		) as HTMLCanvasElement;
		const ctx = canvas.getContext('2d');

		let week_day = this.dataAgressions?.category_counts?.week_day;

		this.noWeekdayData = this.isAllDataZero(week_day);

		let colors = [
			'#180064',
			'#2C009E',
			'#5B43D9',
			'#8F7FFF',
			'#C8BFFF',
			'#5CDBBD',
			'#006B58',
		];

		if (week_day) {
			let week_day_key = Object.keys(week_day);
			let dataSetWeekDays = [];
			// Obtém os valores (quantidades) correspondentes do objeto sublocality
			let quantidades = week_day_key.map((day) => week_day[day]);

			week_day_key.forEach((day, index) => {
				dataSetWeekDays.push({
					label: translateWeekDay(Number(day)),
					data: [quantidades[index]],
					backgroundColor: colors[index], // Cor para a categoria 'Motorista'
					barPercentage: 0.6,
					categoryPercentage: 0.8,
				});
			});

			var data = {
				labels: [''],
				datasets: dataSetWeekDays,
			};

			if (this.weekdayChart) this.weekdayChart.destroy();

			this.weekdayChart = new Chart(ctx, {
				type: 'bar',
				data: data,
				options: {
					responsive: true,

					tooltips: {
						callbacks: {
							label: function (tooltipItem, data) {
								var dataset = data.datasets[tooltipItem.datasetIndex];
								var index = tooltipItem.index;
								return `${dataset.label}: ${dataset.data[index]} (${
									weekdaysPercentages[reverseTranslateWeekDay(dataset.label)]
								})`;
							},
						},
					},

					legend: {
						display: false,
						position: 'bottom', // Posição da legenda
						align: 'center', // Alinhamento da legenda
						labels: {
							usePointStyle: false, // Usar estilo de ponto (cor do item da legenda)
							boxWidth: 12, // Tamanho da caixa da legenda
							fontColor: '#938F94', // Cor da fonte da legenda
						},
					},
					scales: {
						xAxes: [
							{
								ticks: {
									beginAtZero: true,
								},
								gridLines: {
									display: false,
								},
							},
						],
						yAxes: [
							{
								ticks: {
									beginAtZero: true,
									fontColor: '#938F94',
								},
								gridLines: {
									color: 'rgba(229,222,255)', // Cor do grid x
									borderDash: [10, 5], // Padrão de traço (5 pixels sólidos, 5 pixels vazios)
									borderDashOffset: 10, // Deslocamento do padrão de traço
									drawBorder: false, // Não desenhar a borda do gráfico
									//drawOnChartArea: false, // Não desenhar sobre a área do gráfico
									drawTicks: false, // Não desenhar os ticks,
									zeroLineColor: 'rgba(229,222,255)', // Cor da linha zero
									zeroLineBorderDash: [10, 5], // Padrão de traço da linha zero
									zeroLineBorderDashOffset: 10, // Deslocamento do padrã
								},
							},
						],
					},
				},
			});
		}
	}

	isAllDataZero(obj: any): boolean {
		for (const key in obj) {
			if (obj.hasOwnProperty(key)) {
				if (typeof obj[key] === 'object') {
					if (!this.isAllDataZero(obj[key])) {
						return false;
					}
				} else if (obj[key] !== 0) {
					return false;
				}
			}
		}
		return true;
	}

	turnoChart: Chart | null = null;
	noTurnoData = false;
	createGraphTurno() {
		const canvas = document.getElementById(
			this.elId + 'myChartTurno'
		) as HTMLCanvasElement;
		const ctx = canvas.getContext('2d');

		let hour_group = this.dataAgressions?.category_counts?.hour_group || {};

		this.noTurnoData = this.isAllDataZero(hour_group);
		delete hour_group['Não informado'];
		const order = ['Manhã', 'Tarde', 'Noite', 'Madrugada'];
		for (let category in hour_group) {
			let hours = hour_group[category];

			order.forEach((hour) => {
				if (!Object.keys(hours).includes(hour)) {
					hours[hour] = 0;
				}
			});

			const sortedHours = Object.keys(hours)
				.sort((a, b) => order.indexOf(a) - order.indexOf(b))
				.reduce((obj, key) => {
					obj[key] = hours[key];
					return obj;
				}, {});

			hour_group[category] = sortedHours;
		}

		let colors = ['#C8BFFF', '#7E6CFE', '#5B43D9', '#180064']; // adicionei a segunda cor provisoriamente

		if (hour_group) {
			let dataSethourGroup = [];

			order.forEach((hour) => {
				let values = [];
				Object.keys(hour_group).forEach((place) => {
					values.push(hour_group[place][hour]);
				});

				dataSethourGroup.push({
					label: hour,
					data: values,
					backgroundColor: colors[order.indexOf(hour)],
					barPercentage: 0.6,
					categoryPercentage: 0.8,
				});
			});

			var data = {
				labels: Object.keys(hour_group),
				datasets: dataSethourGroup,
			};

			if (this.turnoChart) this.turnoChart.destroy();

			this.turnoChart = new Chart(ctx, {
				type: 'horizontalBar',
				data: data,
				options: {
					tooltips: {
						callbacks: {
							label: function (tooltipItem, data) {
								let label =
									data.datasets[tooltipItem.datasetIndex].label + ': ' || '';

								if (label) {
									label += tooltipItem.xLabel;

									const index = tooltipItem.index;
									let total = 0;

									data.datasets.forEach((dataset) => {
										const value = dataset.data[index];
										if (typeof value === 'number') {
											total += value;
										}
									});

									const value = tooltipItem.xLabel as number;
									const percentage = ((value / total) * 100).toFixed(2);
									label += ` (${percentage}%)`;
								}

								return label;
							},
						},
					},
					responsive: true,
					legend: {
						display: false,
						position: 'bottom',
						align: 'center',
						labels: {
							usePointStyle: false,
							boxWidth: 12,
							fontColor: '#938F94',
						},
					},
					scales: {
						xAxes: [
							{
								stacked: true,
								ticks: {
									beginAtZero: true,
									fontColor: '#938F94',
								},
								gridLines: {
									color: 'rgba(229,222,255)',
									borderDash: [10, 5],
									borderDashOffset: 10,
									drawBorder: false,
									drawTicks: false,
									zeroLineColor: 'rgba(229,222,255)',
									zeroLineBorderDash: [10, 5],
									zeroLineBorderDashOffset: 10,
								},
							},
						],
						yAxes: [
							{
								stacked: true,
								ticks: {
									beginAtZero: true,
								},
								gridLines: {
									display: false,
								},
							},
						],
					},
				},
			});
		}
	}
}

// Função para ordenar os objetos
function ordenarPorHora(objA, objB) {
	if (objA.week_day < objB.week_day) {
		return -1;
	} else if (objA.week_day > objB.week_day) {
		return 1;
	} else {
		// Se os week_day forem iguais, ordena pelo campo hour
		return objA.hour - objB.hour;
	}
}

function agruparPorWeekDay(dados): number[][] {
	// Crie um objeto para armazenar os valores agrupados por 'week_day' e 'hour'
	const resultado = {};

	// Defina uma lista ordenada de horas
	const horasOrdenadas = [
		'6h',
		'7h',
		'8h',
		'9h',
		'10h',
		'11h',
		'12h',
		'13h',
		'14h',
		'15h',
		'16h',
		'17h',
		'18h',
		'19h',
		'20h',
		'21h',
		'22h',
		'23h',
		'00h',
		'1h',
		'2h',
		'3h',
		'4h',
		'5h',
	];

	// Inicialize o objeto resultado com arrays vazios para cada dia da semana
	for (let i = 0; i < 7; i++) {
		resultado[i] = new Array(24).fill(0); // Inicialize com zeros para todas as horas
	}

	// Percorra os objetos e agrupe os valores 'count' por 'week_day' e 'hour'
	dados.forEach((obj) => {
		const { week_day, hour, count } = obj;
		const horaFormatada = `${hour}h`;

		resultado[week_day][horasOrdenadas.indexOf(horaFormatada)] = count;
	});

	return Object.values(resultado);
}

function translateWeekDay(week_day) {
	switch (week_day) {
		case 0:
			return 'Domingo';
		case 1:
			return 'Segunda';
		case 2:
			return 'Terça';
		case 3:
			return 'Quarta';
		case 4:
			return 'Quinta';
		case 5:
			return 'Sexta';
		case 6:
			return 'Sábado';
	}
}

function reverseTranslateWeekDay(day_name) {
	switch (day_name) {
		case 'Domingo':
			return 0;
		case 'Segunda':
			return 1;
		case 'Terça':
			return 2;
		case 'Quarta':
			return 3;
		case 'Quinta':
			return 4;
		case 'Sexta':
			return 5;
		case 'Sábado':
			return 6;
		default:
			return null;
	}
}

function translateTurn(hour) {
	switch (hour) {
		case 'AFTERNOON':
			return 'Tarde';
		case 'MORNING':
			return 'Manhã';
		case 'NIGHT':
			return 'Noite';
			return 'Não informado';
	}
}
